import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { useState } from 'react';
import { getPrimaryTracker } from 'usage-tracker-container';
import { NavItemEnum } from '../../constants/routing/NavItems';
import useCreditsPageNavItemTabs from '../../hooks/useCreditsPageTabNavItems';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector, currentProductVersionSelector, currentSkuIdForProductSelector, currentSuiteSkuIdsForProductLevelSelector } from '../../selectors/ProductsSelectors';
import { getProductLineForNavItem } from '../../utils/routingUtils';
import { trackButtonClick } from '../../v2/utils/tracking/trackingEventUtils';
import BillingNameTitle from './BillingNameTitle';
import NavItemTabs from './NavItemTabs';
import UnlockAIContentLayout from './UnlockAIContentLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnlockAIContentTabLayout = () => {
  const {
    tabs
  } = useCreditsPageNavItemTabs();
  const [subscreen, setSubscreen] = useState(tabs[0]);
  const productLine = getProductLineForNavItem(subscreen);
  const billingNameKey = useAppSelector(state => {
    if (subscreen === NavItemEnum.SUITE || !productLine) return 'crm-suite-starter-bundle';
    const productVersion = currentProductVersionSelector(state, {
      productLine,
      productLevel: 'PROFESSIONAL'
    });
    if (!productVersion) return null;
    return billingNameKeySelector(state, {
      skuId: productVersion.skuId
    });
  });
  const skuIds = useAppSelector(state => {
    if (subscreen === NavItemEnum.SUITE || !productLine) {
      return currentSuiteSkuIdsForProductLevelSelector(state, {
        productLevel: 'STARTER'
      });
    }
    const skuId = currentSkuIdForProductSelector(state, {
      productLine,
      productLevel: 'PROFESSIONAL'
    });
    if (!skuId) return [];
    return [skuId];
  });
  const title = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "pricingPage.pages.hubspot-credits.unlockAI.title.withBillingName",
    options: {
      billingName: billingNameKey ? /*#__PURE__*/_jsx(BillingNameTitle, {
        billingNameKey: billingNameKey
      }) : null
    }
  });
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(NavItemTabs, {
      selected: subscreen,
      setSelected: tab => {
        trackButtonClick({
          action: 'click nav item tab',
          value: tab,
          tab
        });
        getPrimaryTracker().setProperties({
          subscreen: tab
        });
        setSubscreen(tab);
      },
      tabs: tabs
    }), /*#__PURE__*/_jsx(UnlockAIContentLayout, {
      subscreen: subscreen,
      unlockHubSpotCreditsSkuIds: skuIds,
      title: title
    })]
  });
};
export default UnlockAIContentTabLayout;